module.exports = __webpack_public_path__ + "static/img/投诉建议-EN.ec4bf62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/投诉建议-EN.jpg
// module id = mWzb
// module chunks = 17